<template>
  <div class="high_register_new">
    <div class="main-content-wrap">
      <div class="cont_box">
        <div class="header">
          <img class="logo" src="@/assets/images/footballAssociation.png">
          <img class="title" src="@/assets/images/title_picture.png">
        </div>
        <div class="main">
          <div class="header_wrap">
            <span class="btn nav_btn" @click="back">返回</span>
            <img src="@/assets/images/sign_up_title.png" alt="中国足协高端培训班报名">
          </div>
          <vue-scroll :ops="vuescrollOpt">
            <div class="form_wrap">
              <div class="form_cont">
                <el-form
                  :model="formData"
                  :rules="settingFormRules"
                  ref="formData"
                  label-width="90px"
                  size="medium"
                  class="form-cont"
                >
                  <el-form-item label="证件号码">
                    <el-input v-model.trim="formData.idNum" disabled></el-input>
                  </el-form-item>
                  <el-form-item label="姓名">
                    <el-input v-model.trim="formData.username" disabled></el-input>
                  </el-form-item>
                  <el-form-item label="手机号" prop="phonenumber">
                    <el-input v-model.trim="formData.phonenumber" placeholder="请输入手机号"></el-input>
                  </el-form-item>

                  <el-form-item label="验证码" prop="verificationCode">
                    <el-input
                      v-model.trim="formData.verificationCode"
                      placeholder="请输入验证码"
                      class="code"
                    ></el-input>

                    <div class="getcode" v-if="codeFlag" @click="sendcode">获取验证码</div>
                    <div class="waittime" v-else>{{sec}}秒后重新发送</div>
                  </el-form-item>
                  <el-form-item label="密码" prop="password">
                    <el-input v-model.trim="formData.password" placeholder="请输入密码" type="password"></el-input>
                  </el-form-item>
                  <el-form-item label="确认密码" prop="password1">
                    <el-input
                      v-model.trim="formData.password1"
                      placeholder="请再次输入密码"
                      type="password"
                    ></el-input>
                  </el-form-item>
                  <div class="btns btn-registerNew">
                    <el-button type="primary" @click="back">上一步</el-button>
                    <el-button type="primary" @click="commit">注册并进入报名</el-button>
                  </div>
                </el-form>
              </div>
            </div>
          </vue-scroll>
        </div>
      </div>
    </div>
    <yioks-tips
      :showTips="tipsFlag"
      :loading="repeatSubmit"
      tips="请确认是否继续注册？"
      @hideTips="hideTipsDialog"
    ></yioks-tips>
    <app-footer></app-footer>
  </div>
</template>

<script>
import createScrollOpt from "@/assets/js/vuescrollOption";
import { getLogin, getLoginSalt } from "@/api/common/login";
import {personnel_send_verification, enroll_personnel_register} from "@/api/ab_signup/api";
import { hex_hmac_sha256 } from "@/assets/js/sha";
import { mapMutations } from "vuex";
import { storageData } from "@/assets/js/storage";
import {routerJump} from "@/assets/js/yioksRouter";

export default {
  name: "high-register-new",
  components: {
    "yioks-tips": () => import("@/components/Tips/Dialog"),
    "app-footer": () => import("@/components/LayOut/Common/Footer")
  },
  created() {
    this.nonce_str = this.uuid();
  },
  data() {
    const settingFormRules = {
      verificationCode: [
        {
          required: true,
          validator: (rule, val, callback) => {
            if (!this.$yioks.code(val)) {
              callback(new Error("请输入有效的验证码"));
            } else {
              if (!this.phoneFlag) {
                callback();
              } else {
                this.phoneFlag = false;
                callback(new Error(this.phoneMsg));
              }
            }
          },
          trigger: "blur"
        }
      ],
      phonenumber: [
        {
          required: true,
          validator: (rule, val, callback) => {
            if (!this.$yioks.phone(val)) {
              callback(new Error("请输入有效的手机号码"));
            } else {
              if (!this.numberFlag) {
                callback();
              } else {
                this.numberFlag = false;
                callback(new Error(this.numberMsg));
              }
            }
          },
          trigger: "blur"
        }
      ],
      password: [
        {
          required: true,
          validator: (rule, val, callback) => {
            if (!this.$yioks.pwd(val)) {
              callback(new Error("8—16位字母（区分大小写）和数字组合"));
            } else {
              if (this.formData.password1 !== "") {
                this.$refs.formData.validateField("password1");
              }
              callback();
            }
          },
          trigger: "blur"
        }
      ],
      password1: [
        {
          required: true,
          validator: (rule, val, callback) => {
            if (!this.$yioks.pwd(val)) {
              callback(new Error("8—16位字母（区分大小写）和数字组合"));
            } else if (val !== this.formData.password) {
              callback(new Error("两次输入的密码不一致"));
            } else {
              callback();
            }
          },
          trigger: "blur"
        }
      ]
    };
    return {
      tipsFlag: false,
      puuid: this.$route.query.puuid,
      vuescrollOpt: createScrollOpt(),
      settingFormRules,
      codeFlag: true,
      phoneFlag: false,
      numberFlag: false,
      repeatSubmit: false,
      phoneMsg: "",
      numberMsg: "",
      sec: 60,
      nonce_str: "",
      formData: {
        username: this.$route.query.name,
        idNum: this.$route.query.id_number,
        verificationCode: "",
        phonenumber: "",
        password: "",
        password1: ""
      },
      verification: {
        verify: false,
        msg: ""
      }
    };
  },
  methods: {
    ...mapMutations(["setHeartBeat", "clearHeartBeat", "updateUserInfo"]),
    commit() {
      this.$refs.formData.validate(valid => {
        if (valid) {
          // 打开弹窗
          this.tipsFlag = true;
        } else {
          this.$message.error("请检查所填写的内容是否正确");
        }
      });
    },
    hideTipsDialog(bool, flag) {
      this.tipsFlag = bool;
      if (flag) {
        this.next();
      }
    },
    next() {
      this.repeatSubmit = true;
      enroll_personnel_register({
        name: this.formData.username,
        mobile_phone: this.formData.phonenumber,
        code: this.formData.verificationCode,
        id_number: this.formData.idNum,
        password: hex_hmac_sha256(
          this.nonce_str,
          this.formData.password
        ).toUpperCase(),
        affirm_password: hex_hmac_sha256(
          this.nonce_str,
          this.formData.password1
        ).toUpperCase(),
        regist_salt: this.nonce_str,
        puuid: this.puuid
      })
        .then(res => {
          if (Number(res.data.status) === 0) {
            // 保存报名uuid
            const {enroll_uuid} = res.data.result;
            // 进行登录操作
            const password = hex_hmac_sha256(this.nonce_str, this.formData.password).toUpperCase();
            this.getSalt(this.formData.idNum, password, enroll_uuid);
          } else if (Number(res.data.status) === 109) {
            this.repeatSubmit = false;
            this.phoneFlag = true;
            this.phoneMsg = res.data.msg;
            this.$refs["formData"].validateField("verificationCode");
            this.$message.error(res.data.msg);
          } else if (Number(res.data.status) === 405) {
            this.repeatSubmit = false;
            this.numberFlag = true;
            this.numberMsg = res.data.msg;
            this.$refs["formData"].validateField("phonenumber");
            this.$message.error(res.data.msg);
          } else {
            this.repeatSubmit = false;
            this.$message.error(res.data.msg);
          }
        })
        .catch(err => {
          // 取消弹窗
          this.repeatSubmit = false;
          console.error(err);
        });
    },
    getSalt(user_name, pwb, enroll_uuid) {
      if(user_name === 18){
        user_name = user_name.toUpperCase();
      }
      getLoginSalt({username: user_name})
        .then(res => {
          // console.log(res);
          if (Number(res.data.status) === 0) {
            const {login_token} = res.data.result;
            const loginPwb = hex_hmac_sha256(login_token, pwb + user_name).toUpperCase();
            this.login(this.formData.idNum, loginPwb, 1, "registration", enroll_uuid);
          } else {
            this.repeatSubmit = false;
            this.$message.error(res.data.msg);
            console.info(res)
          }
        })
        .catch(err => {
          this.repeatSubmit = false;
          console.error(err);
        });
    },
    login(user_name, pwd, force, userType,enroll_uuid) {
      let obj = {
        username: user_name,
        password: pwd,
      };
      force && Object.assign(obj, {force: force});
      userType && Object.assign(obj, {userType: userType});
      getLogin(obj)
        .then(res => {
          this.repeatSubmit = false;
          if (res.data.status === 0) {
            const {user_info} = res.data.result;
            const token = user_info.token;
            const user_type = user_info.member_type;
            /* 更新状态管理用户信息 */
            this.updateUserInfo(user_info);
            /* 保存token，调整路由 */
            this.routerLogin(token, user_type, enroll_uuid);
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(err => {
          this.repeatSubmit = false;
          console.error(err);
        });
    },
    routerLogin(token, userType, enroll_uuid) {
      this.setHeartBeat(); // 心跳
      storageData.setToken(token);
      storageData.setUserType(userType);
      const path = routerJump();
      this.$router.replace({
        path,
        query: {enroll_uuid: enroll_uuid}
      });
    },
    countdown() {
      // console.log(this.data.sec)
      const timer = setInterval(() => {
        this.$data.sec = this.$data.sec - 1;
        if (this.$data.sec === 0) {
          this.$data.sec = 60;
          this.$data.codeFlag = true;
          clearInterval(timer);
        }
      }, 1000);
    },
    sendcode() {
      if (!this.$yioks.phone(this.formData.phonenumber)){
        this.$refs["formData"].validateField("phonenumber");
        return
      }
      personnel_send_verification({
        mobile_phone: this.formData.phonenumber
      })
        .then(res => {
          if (Number(res.data.status) === 0) {
            this.$message.success("验证码发送成功");
            this.codeErr = false;
            this.codeFlag = false;
            /* 倒计时 */
            this.countdown();
          } else if (
            Number(res.data.status) === 421 ||
            Number(res.data.status) === 420 ||
            Number(res.data.status) === 419
          ) {
            this.phoneFlag = true;
            this.phoneMsg = res.data.msg;
            this.$refs["formData"].validateField("verificationCode");
            this.$message.error(res.data.msg);
          } else if (Number(res.data.status) === 405) {
            this.numberFlag = true;
            this.numberMsg = res.data.msg;
            this.$refs["formData"].validateField("phonenumber");
            this.$message.error(res.data.msg);
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    uuid() {
      let s = [];
      const hexDigits = "0123456789abcdef";
      for (let i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = "";
      return s.join("");
    },
    back() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="stylus">
@import '~@/assets/css/variable';
@import '~@/assets/css/mixin';

.high_register_new {
  display: block;
  width: 100%;
  height: 100%;

  .main-content-wrap {
    height: calc(100% - 60px);
    display: flex;
    justify-content: center;
    user-select: none;
    color: $color_white;
    font-size: $font_size_medium;
    line-height: inherit;

    .cont_box {
      display: block;
      width: 890px;
      padding-top: 95px;

      .header {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 20px;

        .logo {
          width: 120px;
          height: 120px;
          margin-right: 15px;
        }
      }

      .main {
        display: block;
        height: 608px;
        padding: 20px 30px 10px;
        background-color: $block_bg_color_base;
        box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
        position: relative;
        color: $color_white;

        .header_wrap {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          margin: 0 30px 15px;
          padding-bottom: 10px;
          border-bottom: 1px solid #ccc;

          img {
            padding-left: 120px;
          }
        }

        .btn {
          display: inline-block;
          line-height: 1;
          white-space: nowrap;
          cursor: pointer;
          text-align: center;
          outline: none;
          border-radius: 5px;
          padding: 8px 16px;
          background-color: $color_suc;
        }

        .form_wrap {
          display: block;
          padding: 0 100px;

          .title {
            display: block;
            text-align: center;
            font-size: 32px;
            letter-spacing: 0.05em;
            // font-weight bolder
            margin-bottom: 20px;
          }

          .form_cont {
            display: block;
            margin: 0 100px;
            padding-top: 20px;

            .el-form-item {
              margin-bottom: 30px;

              .code {
                width: 160px;
              }

              .waittime {
                width: 160px;
                margin-left: 20px;
                display: inline-block;
                line-height: 1.5;
                white-space: nowrap;
                cursor: pointer;
                text-align: center;
                outline: none;
                padding: 8px 16px;
                background-color: #909399;
              }

              .getcode {
                width: 160px;
                margin-left: 20px;
                display: inline-block;
                line-height: 1.5;
                white-space: nowrap;
                cursor: pointer;
                text-align: center;
                outline: none;
                padding: 8px 16px;
                background-color: #4cd964;
              }
            }

            .code-wrap {
              position: relative;
              display: block;
              height: 40px;
              margin: 0 20px 30px;
              display: flex;

              // justify-content flex-end
              // padding-left 30px
              .code_img_wrap {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 150px;
                text-align: center;
                background-color: $color_white;

                img {
                  display: block;
                  width: 100%;
                  height: 100%;
                }

                .loading-code {
                  font-size: 30px;
                  color: $color_black;
                }
              }

              .refresh-code {
                flex: 1;
                margin-left: 10px;
                padding: 0 10px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: $color_white;
                background-color: $color_suc;
                cursor: pointer;
              }
            }

            .btns {
              display: block;
              text-align: center;
            }

            .el-form-item__label {
              color: $color_white;
              font-size: 16px;
            }

            .el-radio {
              color: $color_white;
            }

            .el-input__inner, .el-textarea__inner {
              // border-radius 0
            }

            .el-input.is-disabled .el-input__icon {
              color: #666;
            }

            .el-form-item.is-required .el-form-item__label:before {
              color: inherit;
            }

            .el-input.is-disabled .el-input__inner {
              input-disabled();
            }

            .btn-registerNew {
              display: flex;
              justify-content: space-between;
            }
          }
        }
      }
    }
  }
}
</style>
